import React from 'react';

export default function ProgressBar({ value = 0, color = '#E8502A', height = 6, trackColor = '#EDEAE3' }) {
  const safeValue = Math.max(0, Math.min(100, Number(value) || 0));
  return (
    <div
      style={{
        height,
        background: trackColor,
        borderRadius: 999,
        overflow: 'hidden',
        width: '100%',
      }}
      role="progressbar"
      aria-valuenow={safeValue}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        style={{
          height: '100%',
          width: `${safeValue}%`,
          background: color,
          borderRadius: 999,
          transition: 'width 600ms ease',
        }}
      />
    </div>
  );
}
